import journal from '@/api/journal'
import { vissue, issue, volume } from '@/api/vissue'
// import articalNumber from './artical-number'
import lineChart from './line-chart'
// import pieChart from './pie-chart'
import { statisticJournalCountry } from '@/api/statistic'
import help from '@/utils/help'
import { mapGetters } from 'vuex'

export default {
  components: {
    // articalNumber,
    lineChart
    // pieChart
  },
  data() {
    return {
      params: {
        journalId: '',
        volumeId: '',
        // issueId: '',
        status: ''
      },
      journalList: [],
      volumeList: [],
      issueList: [],
      Status: {
        '': 'All',
        PUBLISHED: 'Online',
        UNPUBLISHED: 'Pending Online',
        RETRACTION: 'retraction'
      },
      issueId: '',
      zoneArticalNumber: {},
      issueIdPie: '',
      zoneArticalArry: [],
      zoneArtical: {
        oneZoneNum: 'Zone I',
        twoZoneNum: 'Zone II',
        threeZoneNum: 'Zone III'
      },
      pieOption: null,
      colorType: ['#1E1D40', '#174A87', '#0091FF']
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  async mounted() {
    await this.getJournalList()
  },
  methods: {
    async getJournalList() {
      this.journalList = await journal.userGet({ released: true })
      const flag = this.journalList.some(item => {
        if (item.id === localStorage.getItem('journalId')) {
          this.params.journalId = item.id
          return true
        }
      })
      if (!flag) {
        this.params.journalId = this.journalList[0] && this.journalList[0].id
        localStorage.setItem('journalId', this.params.journalId)
      }
      if (!this.params.journalId) {
        return
      }
      this.getVolumeCode(this.params.journalId)
    },
    async getVolumeCode(journalId) {
      this.volumeList = await volume.getCode({ journalId, released: true })
      this.params.volumeId = this.volumeList[0] && this.volumeList[0].id
      this.params.issueId = ''
      localStorage.setItem('journalId', journalId)
      this.getIssueCode(this.params.volumeId)
    },
    getIssueCode(val) {
      const arr = this.volumeList.find(item => {
        if (item.id === val) {
          return item
        }
      })
      this.issueList = arr.issueCodeList
      // this.params.issueId =
      //   this.issueList[this.issueList.length - 1] &&
      //   this.issueList[this.issueList.length - 1].id
      if (this.issueList && this.issueList.length > 0) {
        this.issueId = this.issueIdPie =
          this.issueList[this.issueList.length - 1] &&
          this.issueList[this.issueList.length - 1].id
      }
      this.getData()
    },
    async exp() {
      const res = await statisticJournalCountry.export(this.params)
      help.download(res.url, res.fileName)
    },
    // number
    async getData() {
      const data = Object.assign(this.params, {
        issueId: this.issueIdPie
      })
      const response = await statisticJournalCountry.zone(data)
      this.zoneArticalNumber = response || {}
      let arr = []
      for (const key in this.zoneArtical) {
        arr.push({
          name: this.zoneArtical[key],
          value: (response && response[key]) || 0
        })
      }
      this.zoneArticalArry = arr || []
      this.optionType()
    },
    async getNumber() {
      const data = Object.assign(this.params, {
        issueId: this.issueId
      })
      this.zoneArticalNumber = await statisticJournalCountry.zone(data)
    },
    async getPie() {
      const data = Object.assign(this.params, {
        issueId: this.issueIdPie
      })
      const response = await statisticJournalCountry.zone(data)
      let arr = []
      for (const key in this.zoneArtical) {
        arr.push({
          name: this.zoneArtical[key],
          value: (response && response[key]) || 0
        })
      }
      this.zoneArticalArry = arr
      this.optionType()
    },
    getEchart() {
      var echarts = require('echarts')
      let myChart = echarts.init(document.getElementById('zone-pie-chart'))
      myChart.setOption(this.pieOption)
    },
    optionType() {
      this.pieOption = {
        tooltip: {
          trigger: 'item',
          formatter: function(params) {
            let res = `<div>${params.name}</div><span>${params.percent}%</span> / <span>${params.value}</span>`
            return res
          },
          extraCssText:
            'background: #fff; border-radius: 2px;color: #1E1D40;border: 1px solid #1E1D40;;font-size:12px'
        },
        legend: {
          bottom: '0',
          left: 'center',
          icon: 'circle',
          itemWidth: 20,
          itemHeight: 20,
          textStyle: {
            // lineHeight: 0,
            // fontSize: 16
          }
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              // borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2,
              emphasis: {
                //对应的鼠标悬浮效果
                show: true
              }
            },
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            color: this.colorType,
            data: this.zoneArticalArry
          }
        ]
      }
      this.getEchart()
    }
  }
}
